import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TextDialogData } from './text-dialog-data';

@Component({
    selector: 'shared-text-dialog',
    templateUrl: './text-dialog.component.html',
    styleUrls: ['./text-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextDialogComponent<TReturn> {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TextDialogData<TReturn>) {

  }
}
